module.exports = __webpack_public_path__ + "static/profile-f58eec911d058282cea787a034cfcc1c.png";